import React from "react";
import InputText from "../../../../components/inputs/InputText";

/** Total / discount / net and card + cash, shared by patient and staff release. */
function ReleasePayment({ total, netTotal, discount, card, cash, onChange }: ReleasePaymentProps) {
  return (
    <>
      <div className="grid grid-cols-2 gap-2.5">
        <InputText name="total" label="Total" value={total} onChange={onChange} isDisable={true} />
        <InputText name="discount" label="Discount" value={discount} onChange={onChange} />
      </div>

      <div className="p-2.5 bg-emerald-50 dark:bg-emerald-900/40 rounded-lg">
        <p className="text-xs text-emerald-700 dark:text-emerald-300">
          Net Total: <span className="font-bold text-sm">{netTotal}</span>
        </p>
      </div>

      <div className="grid grid-cols-2 gap-2.5">
        <InputText name="card" label="Card" value={card} onChange={onChange} />
        <InputText name="cash" label="Cash" value={cash} onChange={onChange} />
      </div>
    </>
  );
}

export default ReleasePayment;

interface ReleasePaymentProps {
  total: number;
  netTotal: number;
  discount: number | string;
  card: number | string;
  cash: number | string;
  onChange: (e: any) => void;
}
